module.exports = __webpack_public_path__ + "static/media/custom.542f294f.png";